import { defineAsyncComponent, type Component } from 'vue'

/**
 * 背景组件注册表
 * key 与 CustomWallpaperConfig.component 字段对应
 */
export const BackgroundComponents: Record<string, Component> = {
  ColorBends: defineAsyncComponent(() => import('./ColorBends/index.vue')),
  Grainient: defineAsyncComponent(() => import('./Grainient/index.vue')),
  Aurora: defineAsyncComponent(
    () => import('@/views/device/mouse/performance/components/AuroraBackground.vue'),
  ),
}
